import { createAsyncThunk } from "@reduxjs/toolkit";
import { redirectToCartPage } from "@store/utils/cartHelpers";

import { getCurrentMagentoClient, type Order } from "@jti/magento";

type FetchOrderArgs = {
  orderId: string;
  showPricesWithTaxExcluded?: boolean;
};

const fetchOrderDeclaration = (isFreeTrial: boolean) =>
  createAsyncThunk<Order, FetchOrderArgs>(
    isFreeTrial ? "freeTrialOrder/fetchOrder" : "order/fetchOrder",
    async ({ orderId, showPricesWithTaxExcluded = false }, { rejectWithValue }) => {
      try {
        const order = await getCurrentMagentoClient(isFreeTrial).getCustomerOrder(orderId, showPricesWithTaxExcluded);

        return order;
      } catch (error) {
        redirectToCartPage();
        return rejectWithValue(error);
      }
    }
  );
export const fetchOrder = fetchOrderDeclaration(false);
export const fetchFreeTrialOrder = fetchOrderDeclaration(true);
